import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import styled from '@emotion/styled'
import { useArticles } from 'utils/api/hooks'
import Link from 'components/common/A'
import CursorBox from 'components/common/CursorPointerBox.js'

const ImgRect = styled.div`
  position: relative;
  padding-top: 70%;
  margin: 0 8px;
  border-radius: 12px;
  overflow: hidden;
`
const Absolute = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`
const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const LatestArticle = () => {
  const { data: articles, isLoading: isArticleLoading } = useArticles()

  return (
    <>
      {!isArticleLoading && (
        <Box>
          <Typography mb={6} fontWeight="fontWeightBold">
            最新上架
          </Typography>
          <Grid container spacing={2}>
            {articles &&
              articles?.slice(0, 3).map((item) => {
                return (
                  <Grid item xs={4} key={item._id}>
                    <Link href={`/article/${item?.urlId}`} target="_blank">
                      <CursorBox>
                        <ImgRect>
                          <Absolute>
                            <Img
                              alt=""
                              src={
                                item.image?.url ||
                                '/img/img_headshot_default.png'
                              }
                            />
                          </Absolute>
                        </ImgRect>
                        <Typography color="text.minus2" mt={3} mx={2}>
                          {item?.title}
                        </Typography>
                      </CursorBox>
                    </Link>
                  </Grid>
                )
              })}
          </Grid>
        </Box>
      )}
    </>
  )
}

export default LatestArticle
